import { render, staticRenderFns } from "./forgot-password-bb.vue?vue&type=template&id=98e28b06&scoped=true"
import script from "./forgot-password-bb.vue?vue&type=script&lang=js"
export * from "./forgot-password-bb.vue?vue&type=script&lang=js"
import style0 from "./forgot-password-bb.vue?vue&type=style&index=0&id=98e28b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e28b06",
  null
  
)

export default component.exports